export default __webpack_public_path__ + "static/media/image-main-3-w@3x.a5516bbc.webp";